<template>
    <RouterView v-slot="{ Component }">
        <Suspense :timeout="0">
            <template #fallback>
                <div class="flex min-h-screen flex-1 items-center justify-center bg-cover bg-center">
                    <AxModalLoading :loadingText="''" />
                </div>
            </template>
            <component :is="Component" />
        </Suspense>
    </RouterView>
    <AxToast />
    <div class="fixed right-0 bottom-0 p-2 text-xs text-gray-400">
        {{ branchName }} @ {{ commitSha }}
    </div>
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router';
import { AxToast } from '@axxone-system/hades';
import AxModalLoading from '@/shared/blocksUI/AxModalLoading.vue';
declare const __COMMIT_SHA__: string;
declare const __BRANCH_NAME__: string;
const commitSha = __COMMIT_SHA__;
const branchName = __BRANCH_NAME__;

// ──── Composables & Stores ─────

</script>
